<script setup lang="ts">
  import Button from "primevue/button";
  import {useRouter} from "vue-router";

  const router = useRouter()
</script>

<template>
  <div class="flex flex-col max-w-96">
    <h1 class="text-5xl text-black">Tools for the people who care for our pets.</h1>
    <Button class="text-xl mt-10" @click="router.push('/signup')">Sign up for early access</Button>
  </div>
</template>